import { CustomRendererProps, TBlock } from 'react-native-render-html';

import { useMessaging } from 'app/providers/MessagingProvider';

export default function OpenChat({ TDefaultRenderer, ...props }: CustomRendererProps<TBlock>) {
  const { open } = useMessaging();
  return <TDefaultRenderer {...props} onPress={open} />;
}
